import React from 'react';
import { useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { AnimatedClasses } from '../../utils/animatedStyles';
import { IconCry } from '../svgs/IconCry';
import { Loader } from '../ui/Loader';
import { useCloseModal } from './hooks/useCloseModal';
import * as Styles from './styles';

interface MyTicketProps {
  closeHandler: () => void;
}

export const MyTicket: React.FC<MyTicketProps> = ({ closeHandler }) => {
  const { refInnWrapper, closeModal } = useCloseModal(closeHandler);
  const { Sockets, Ticket } = useSelector((store: AppStore) => store);

  const renderBody = () => {
    if (!Sockets.event) return null;
    if (Ticket.loading) return null;
    if (new Date() < new Date(new Date(Sockets.event.dateStart).getTime() - 10 * 24 * 60 * 60 * 1000))
      return (
        <Styles.ModalBodyS>
          <h4>
            Вітаємо! Ваш персональний квиток буде доступний за 10 календарних днів до початку події.
            <br />
            <br />
            Чекаємо на Вас. До зустрічі!
          </h4>
        </Styles.ModalBodyS>
      );
    if (Ticket.data?.link)
      return (
        <Styles.ModalBodyS>
          <h4>
            Вітаємо! Скачайте свій персональний квиток на участь у заході за
            <a
              href={Ticket.data.link}
              target="_blank"
              rel="noreferrer"
              style={{ color: '-webkit-link', textDecoration: 'underline', marginLeft: '5px' }}
            >
              посиланням
            </a>
            . Обов’язково візьміть його з собою — у електронному вигляді або роздрукованим.
          </h4>
          <h4>Якщо виявили помилку в імені, зверніться, будь ласка, до підтримки за номером 0800 21 38 38</h4>
        </Styles.ModalBodyS>
      );
    return (
      <Styles.ModalBodyS>
        <Styles.WrapText>
          Прикро <IconCry />
          <br /> Сталась помилка. Ваш персональний квиток не знайдено. Зверніться, будь ласка, в підтримку за номером 0800 21 38 38
        </Styles.WrapText>
      </Styles.ModalBodyS>
    );
  };

  return (
    <Styles.ModalOuterWrapperS>
      <Styles.ModalInnerWrapperS style={{ maxWidth: '600px' }} ref={refInnWrapper} className={AnimatedClasses.zoomIn}>
        <div style={{ padding: '5px', textAlign: 'right' }}>
          <i style={{ cursor: 'pointer', fontSize: '25px' }} className="bi bi-x" onClick={closeModal} />
        </div>
        {renderBody()}
        {Ticket.loading && <Loader />}
      </Styles.ModalInnerWrapperS>
    </Styles.ModalOuterWrapperS>
  );
};
